import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Zaroori Retail - India's #1 Marketplace Onboarding Service",
  description = "Get your brand listed on Myntra, Nykaa, Ajio, Tata Cliq and 30+ premium marketplaces. Expert onboarding, brand growth & full e-commerce support. 4200+ brands trust us.",
  keywords = "marketplace onboarding, Myntra seller, Nykaa seller, Ajio listing, e-commerce services, brand growth, online marketplace, India retail",
  canonical = "https://zarooriretail.com",
  ogImage = "https://customer-assets.emergentagent.com/job_49e3f0dc-64cb-41b7-891b-65258ccb235b/artifacts/4zp8z6bt_ZR%20landscape%20logo.png",
  type = "website",
  author = "Zaroori Retail",
  structuredData = null,
  article = null,
  noindex = false  // Add noindex prop for pages that shouldn't be indexed
}) => {
  // NOTE (Phase D pre-cleanup, Feb 2026):
  // Default Organization + standalone LocalBusiness blocks removed from this
  // component. Those entities are canonically declared once in /public/index.html
  // and would otherwise be duplicated on every route (5x LocalBusiness on /).
  // SEOHead now only emits page-level structured data when explicitly supplied
  // by the page (WebPage, Article, BlogPosting, Service, etc.).

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Zaroori Retail" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO */}
      <meta name="geo.region" content="IN-PB" />
      <meta name="geo.placename" content="Ludhiana" />
      <meta name="geo.position" content="30.9010;75.8573" />
      <meta name="ICBM" content="30.9010, 75.8573" />
      
      {/* Structured Data (page-level only — Organization/LocalBusiness/WebSite are canonical in /public/index.html) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
